(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.key = this.dataset.storageKey;
      try {
        if (this.hasAttribute('data-closable') && window.sessionStorage.getItem(this.key) === '1') {
          this.hidden = true;
        }
      } catch (error) {
        /* storage unavailable */
      }
      const close = this.querySelector('[data-announcement-close]');
      if (close) close.addEventListener('click', () => this.close());
    }

    close() {
      this.hidden = true;
      try {
        window.sessionStorage.setItem(this.key, '1');
      } catch (error) {
        /* storage unavailable */
      }
      document.dispatchEvent(new CustomEvent('announcement:closed'));
    }
  }

  if (!customElements.get('announcement-bar')) {
    customElements.define('announcement-bar', AnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article"]) return;
  try {
    
  class JournalArticle extends HTMLElement {
    connectedCallback() {
      this.layoutBody();
      this.bindVideo();
    }

    layoutBody() {
      const body = this.querySelector('[data-article-body]');
      if (!body) return;
      const nodes = Array.from(body.childNodes).filter(
        (node) => node.nodeType === 1 || (node.nodeType === 3 && node.textContent.trim() !== '')
      );
      body.innerHTML = '';
      let text = null;
      let figures = null;

      const isImageNode = (node) => {
        if (node.nodeType !== 1) return false;
        if (node.tagName === 'IMG' || node.tagName === 'FIGURE') return true;
        const children = Array.from(node.childNodes).filter(
          (child) => child.nodeType === 1 || child.textContent.trim() !== ''
        );
        return children.length > 0 && children.every((child) => child.nodeType === 1 && (child.tagName === 'IMG' || child.tagName === 'A' && child.querySelector('img')));
      };

      const flushFigures = () => {
        if (!figures) return;
        const count = figures.children.length;
        figures.style.setProperty('--count', String(Math.min(count, 3)));
        figures.classList.toggle('article__figures--single', count === 1);
        figures = null;
      };

      nodes.forEach((node) => {
        if (isImageNode(node)) {
          text = null;
          const images = node.tagName === 'IMG' ? [node] : Array.from(node.querySelectorAll('img'));
          images.forEach((img) => {
            if (!figures || figures.children.length >= 3) {
              flushFigures();
              figures = document.createElement('div');
              figures.className = 'article__figures';
              body.appendChild(figures);
            }
            const figure = document.createElement('figure');
            figure.className = 'article__figure';
            const link = img.closest('a');
            const media = link ? link.cloneNode(false) : document.createElement('span');
            media.className = 'article__figure-media';
            media.appendChild(img);
            figure.appendChild(media);
            const caption = (node.tagName === 'FIGURE' && node.querySelector('figcaption')) ? node.querySelector('figcaption').textContent : img.getAttribute('alt');
            if (caption && caption.trim()) {
              const figcaption = document.createElement('figcaption');
              figcaption.textContent = caption.trim();
              figure.appendChild(figcaption);
            }
            figures.appendChild(figure);
          });
          return;
        }

        flushFigures();

        if (node.nodeType === 1 && node.tagName === 'BLOCKQUOTE') {
          text = null;
          const quote = document.createElement('blockquote');
          quote.className = 'article__quote';
          const paragraphs = Array.from(node.querySelectorAll('p'));
          const last = paragraphs[paragraphs.length - 1];
          if (paragraphs.length > 1 && last && /^[-–—]/.test(last.textContent.trim())) {
            const cite = document.createElement('cite');
            cite.textContent = last.textContent.trim();
            last.remove();
            paragraphs.slice(0, -1).forEach((p) => quote.appendChild(p));
            quote.appendChild(cite);
          } else {
            while (node.firstChild) quote.appendChild(node.firstChild);
          }
          body.appendChild(quote);
          return;
        }

        if (!text) {
          text = document.createElement('div');
          text.className = 'article__text';
          body.appendChild(text);
        }
        text.appendChild(node);
      });
      flushFigures();
    }

    bindVideo() {
      this.querySelectorAll('[data-video-toggle]').forEach((button) => {
        const video = button.querySelector('video');
        const label = button.querySelector('[data-video-label]');
        if (!video) return;
        button.addEventListener('click', () => {
          if (video.paused) {
            video.play().then(() => {
              button.classList.add('is-playing');
              label.textContent = label.dataset.pause;
            }).catch(() => {});
          } else {
            video.pause();
            button.classList.remove('is-playing');
            label.textContent = label.dataset.play;
          }
        });
      });
    }
  }

  if (!customElements.get('journal-article')) {
    customElements.define('journal-article', JournalArticle);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('[data-cart-panel]');
      this.overlay = this.querySelector('[data-cart-overlay]');
      this.isOpen = false;

      this.overlay.addEventListener('click', () => this.close());
      this.addEventListener('click', (event) => {
        const close = event.target.closest('[data-cart-close]');
        if (close) {
          if (close.tagName !== 'A') event.preventDefault();
          this.close();
          return;
        }
        const quantityButton = event.target.closest('[data-cart-quantity]');
        if (quantityButton) {
          const item = quantityButton.closest('[data-cart-item]');
          if (item) this.changeQuantity(item.dataset.line, quantityButton.dataset.cartQuantity);
        }
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.isOpen) this.close();
      });
      document.addEventListener('cart:open', () => this.open());
      document.addEventListener('cart:added', () => this.refresh({ open: true }));
      document.querySelectorAll('[data-cart-toggle]').forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.open();
        });
      });
      this.loadRecommendations();
    }

    async loadRecommendations() {
      const block = this.querySelector('[data-cart-recs]');
      if (!block || !block.dataset.url) return;
      try {
        const response = await fetch(block.dataset.url);
        if (!response.ok) return;
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-cart-recs-grid]');
        const current = block.querySelector('[data-cart-recs-grid]');
        if (fresh && current && fresh.children.length > 0) {
          current.innerHTML = fresh.innerHTML;
          block.hidden = false;
        }
      } catch (error) {
        /* keep fallback */
      }
    }

    open() {
      if (this.isOpen) return;
      this.isOpen = true;
      this.lastFocus = document.activeElement;
      this.classList.remove('is-closing');
      this.classList.add('is-open');
      document.documentElement.classList.add('cart-drawer-open');
      requestAnimationFrame(() => this.panel.focus());
    }

    close() {
      if (!this.isOpen) return;
      this.isOpen = false;
      this.classList.remove('is-open');
      this.classList.add('is-closing');
      document.documentElement.classList.remove('cart-drawer-open');
      const done = () => {
        this.classList.remove('is-closing');
        this.panel.removeEventListener('transitionend', done);
      };
      this.panel.addEventListener('transitionend', done);
      setTimeout(done, 500);
      if (this.lastFocus && typeof this.lastFocus.focus === 'function') this.lastFocus.focus();
    }

    async changeQuantity(line, quantity) {
      this.classList.add('is-loading');
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: Number(line), quantity: Number(quantity) }),
        });
        if (!response.ok) throw new Error('cart change failed');
        await this.refresh({ open: false });
      } catch (error) {
        this.classList.remove('is-loading');
      }
    }

    async refresh({ open }) {
      this.classList.add('is-loading');
      try {
        const response = await fetch(`${window.Shopify.routes.root}?section_id=${this.dataset.sectionId}`);
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-cart-content]');
        const current = this.querySelector('[data-cart-content]');
        if (fresh && current) current.replaceWith(fresh);
        const count = this.querySelector('[data-cart-drawer-count]');
        const total = count ? Number(count.dataset.cartDrawerCount) : null;
        if (total !== null) {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { itemCount: total } }));
        }
        if (open) this.open();
        this.loadRecommendations();
      } finally {
        this.classList.remove('is-loading');
      }
    }
  }

  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', CartDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-seo"] && !Shopify.designMode) return;
  try {
    
  class CollectionSeoText extends HTMLElement {
    connectedCallback() {
      this.body = this.querySelector('[data-seo-body]');
      this.toggle = this.querySelector('[data-seo-toggle]');
      if (!this.body || !this.toggle) return;
      this.toggle.addEventListener('click', () => this.setExpanded(!this.classList.contains('is-expanded')));
      this.measure();
      window.addEventListener('resize', () => this.measure(), { passive: true });
    }

    measure() {
      if (this.classList.contains('is-expanded')) return;
      this.classList.add('is-collapsible');
      const overflows = this.body.scrollHeight > this.body.clientHeight + 2;
      this.classList.toggle('is-collapsible', overflows);
      this.toggle.hidden = !overflows;
    }

    setExpanded(expanded) {
      this.classList.toggle('is-expanded', expanded);
      this.classList.toggle('is-collapsible', true);
      this.toggle.setAttribute('aria-expanded', String(expanded));
      this.toggle.textContent = expanded ? this.toggle.dataset.labelLess : this.toggle.dataset.labelMore;
    }
  }

  if (!customElements.get('collection-seo-text')) {
    customElements.define('collection-seo-text', CollectionSeoText);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  class CollectionFilters extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-filters-form]');
      this.panel = this.querySelector('[data-filter-panel]');
      this.toggle = this.querySelector('[data-filter-toggle]');
      this.label = this.querySelector('[data-filter-label]');
      this.sortSelect = this.querySelector('[data-sort-select]');
      this.sortLabel = this.querySelector('[data-sort-label]');
      this.apply = this.querySelector('[data-filter-apply]');

      if (this.toggle && this.panel) {
        this.toggle.addEventListener('click', () => {
          const open = this.panel.hidden;
          this.panel.hidden = !open;
          this.toggle.setAttribute('aria-expanded', String(open));
          if (this.label) this.label.textContent = open ? this.label.dataset.labelOpen : this.label.dataset.labelClosed;
        });
      }

      if (this.apply) this.apply.hidden = true;

      if (this.form) {
        this.form.addEventListener('change', (event) => {
          if (this.sortSelect && event.target === this.sortSelect && this.sortLabel) {
            this.sortLabel.textContent = this.sortSelect.options[this.sortSelect.selectedIndex].text;
          }
          if (event.target.type === 'number') return;
          this.submit();
        });
        this.form.querySelectorAll('input[type="number"]').forEach((input) => {
          input.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') {
              event.preventDefault();
              this.submit();
            }
          });
          input.addEventListener('blur', () => this.submit());
        });
      }
    }

    submit() {
      const data = new FormData(this.form);
      const params = new URLSearchParams();
      data.forEach((value, key) => {
        if (value !== '') params.append(key, value);
      });
      window.location.href = `${this.form.action}?${params.toString()}`;
    }
  }

  if (!customElements.get('collection-filters')) {
    customElements.define('collection-filters', CollectionFilters);
  }

  class CollectionDescription extends HTMLElement {
    connectedCallback() {
      this.body = this.querySelector('[data-description-body]');
      this.toggle = this.querySelector('[data-description-toggle]');
      if (!this.body || !this.toggle) return;
      this.toggle.addEventListener('click', () => this.setExpanded(!this.classList.contains('is-expanded')));
      this.measure();
      window.addEventListener('resize', () => this.measure(), { passive: true });
    }

    measure() {
      if (this.classList.contains('is-expanded')) return;
      this.classList.add('is-collapsible');
      const overflows = this.body.scrollHeight > this.body.clientHeight + 2;
      this.classList.toggle('is-collapsible', overflows);
      this.toggle.hidden = !overflows;
    }

    setExpanded(expanded) {
      this.classList.toggle('is-expanded', expanded);
      this.classList.add('is-collapsible');
      this.toggle.setAttribute('aria-expanded', String(expanded));
      this.toggle.textContent = expanded ? this.toggle.dataset.labelLess : this.toggle.dataset.labelMore;
    }
  }

  if (!customElements.get('collection-description')) {
    customElements.define('collection-description', CollectionDescription);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cookie-banner"]) return;
  try {
    
  class CookieBanner extends HTMLElement {
    connectedCallback() {
      this.views = {
        banner: this.querySelector('[data-cookie-view="banner"]'),
        manage: this.querySelector('[data-cookie-view="manage"]'),
      };
      this.toggles = Array.from(this.querySelectorAll('[data-cookie-toggle]'));
      this.answered = false;
      this.alwaysShow = this.dataset.alwaysShow === 'true';

      this.querySelector('[data-cookie-accept]').addEventListener('click', () => {
        this.save({ analytics: true, marketing: true, preferences: true });
      });
      this.querySelector('[data-cookie-reject]').addEventListener('click', () => {
        this.save({ analytics: false, marketing: false, preferences: false });
      });
      this.querySelector('[data-cookie-save]').addEventListener('click', () => {
        const values = {};
        this.toggles.forEach((toggle) => {
          values[toggle.dataset.cookieToggle] = toggle.getAttribute('aria-checked') === 'true';
        });
        this.save(values);
      });
      this.querySelector('[data-cookie-manage]').addEventListener('click', () => this.show('manage'));
      this.querySelector('[data-cookie-back]').addEventListener('click', () => {
        if (this.answered) this.hide();
        else this.show('banner');
      });
      this.toggles.forEach((toggle) => {
        toggle.addEventListener('click', () => {
          toggle.setAttribute('aria-checked', String(toggle.getAttribute('aria-checked') !== 'true'));
        });
      });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !this.views.manage.hidden) {
          if (this.answered) this.hide();
          else this.show('banner');
        }
      });
      document.addEventListener('click', (event) => {
        if (event.target.closest('[data-cookie-settings]')) {
          event.preventDefault();
          this.show('manage');
        }
      });

      const start = () => {
        if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
          if (error) return;
          this.api = window.Shopify.customerPrivacy;
          this.evaluate();
        });
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
      else start();
    }

    consent() {
      return this.api ? this.api.currentVisitorConsent() : {};
    }

    evaluate() {
      const consent = this.consent();
      this.answered = Boolean(consent.analytics || consent.marketing || consent.preferences);
      const designMode = window.Shopify && window.Shopify.designMode;
      if (designMode) {
        // Theme editor: show the banner only while its section is selected.
        if (!this.editorBound) {
          this.editorBound = true;
          const section = this.closest('.shopify-section');
          document.addEventListener('shopify:section:select', (event) => {
            if (section && event.target === section) this.show('banner');
          });
          document.addEventListener('shopify:section:deselect', (event) => {
            if (section && event.target === section) this.hide();
          });
        }
        return;
      }
      const needed = this.api.shouldShowBanner() || this.alwaysShow;
      if (!this.answered && needed) this.show('banner');
    }

    show(view) {
      const consent = this.consent();
      this.toggles.forEach((toggle) => {
        const key = toggle.dataset.cookieToggle;
        toggle.setAttribute('aria-checked', String(consent[key] === 'yes'));
      });
      Object.keys(this.views).forEach((key) => {
        const el = this.views[key];
        if (key === view) {
          el.hidden = false;
          requestAnimationFrame(() => el.classList.add('is-visible'));
        } else {
          el.hidden = true;
          el.classList.remove('is-visible');
        }
      });
      document.documentElement.setAttribute('data-cookie-banner-open', '');
      this.views[view].focus({ preventScroll: true });
    }

    hide() {
      Object.values(this.views).forEach((el) => {
        el.hidden = true;
        el.classList.remove('is-visible');
      });
      document.documentElement.removeAttribute('data-cookie-banner-open');
      document.dispatchEvent(new CustomEvent('cookie:resolved'));
    }

    save(values) {
      if (!this.api) return;
      this.api.setTrackingConsent(values, () => {
        this.answered = true;
        this.hide();
      });
    }
  }

  if (!customElements.get('cookie-banner')) {
    customElements.define('cookie-banner', CookieBanner);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    connectedCallback() {
      const dialog = this.querySelector('[data-localization-dialog]');
      const open = this.querySelector('[data-localization-open]');
      const close = this.querySelector('[data-localization-close]');
      if (!dialog || !open) return;
      open.addEventListener('click', () => dialog.showModal());
      if (close) close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
    }
  }

  if (!customElements.get('localization-form')) {
    customElements.define('localization-form', LocalizationForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-card-product"]) return;
  try {
    
  class GiftCardProduct extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-gift-form]');
      this.variantInput = this.querySelector('[data-gift-variant]');
      this.recipient = this.querySelector('[data-gift-recipient]');
      this.send = this.querySelector('[data-gift-send]');
      this.offset = this.querySelector('[data-gift-offset]');
      this.dateWrap = this.querySelector('[data-gift-date]');
      this.dateInput = this.querySelector('[data-gift-date-input]');
      this.cta = this.querySelector('[data-gift-cta]');
      this.error = this.querySelector('[data-gift-error]');
      this.gift = false;
      this.later = false;

      this.querySelectorAll('[data-gift-choice]').forEach((button) => {
        button.addEventListener('click', () => {
          this.querySelectorAll('[data-gift-choice]').forEach((other) => {
            const on = other === button;
            other.classList.toggle('is-selected', on);
            other.setAttribute('aria-pressed', String(on));
          });
          this.variantInput.value = button.dataset.variantId;
          this.querySelectorAll('[data-gift-amount], [data-gift-cta-price]').forEach((el) => {
            el.innerHTML = button.dataset.price;
          });
          this.setLabel(this.cta.dataset.labelAdd);
        });
      });

      this.querySelectorAll('[data-gift-who]').forEach((button) => {
        button.addEventListener('click', () => this.setWho(button.dataset.giftWho));
      });
      this.querySelectorAll('[data-gift-when]').forEach((button) => {
        button.addEventListener('click', () => this.setWhen(button.dataset.giftWhen));
      });

      const message = this.querySelector('[data-gift-message]');
      const count = this.querySelector('[data-gift-count]');
      if (message && count) {
        message.addEventListener('input', () => {
          count.textContent = message.value.length;
        });
      }

      if (this.dateInput) {
        const today = new Date();
        const max = new Date();
        max.setDate(today.getDate() + 90);
        const iso = (d) => d.toISOString().slice(0, 10);
        this.dateInput.min = iso(today);
        this.dateInput.max = iso(max);
      }
      if (this.offset) this.offset.value = String(new Date().getTimezoneOffset());

      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.submit();
      });
      this.form.addEventListener('input', () => this.showError(''));
    }

    setWho(who) {
      this.gift = who === 'other';
      this.querySelectorAll('[data-gift-who]').forEach((button) => {
        const on = button.dataset.giftWho === who;
        button.classList.toggle('is-selected', on);
        button.setAttribute('aria-pressed', String(on));
      });
      this.recipient.hidden = !this.gift;
      this.send.checked = this.gift;
      this.offset.disabled = !this.gift;
      this.querySelectorAll('[data-gift-field]').forEach((field) => {
        field.disabled = !this.gift;
      });
      this.setWhen(this.later ? 'later' : 'now');
      this.showError('');
    }

    setWhen(when) {
      this.later = when === 'later';
      this.querySelectorAll('[data-gift-when]').forEach((button) => {
        const on = button.dataset.giftWhen === when;
        button.classList.toggle('is-selected', on);
        button.setAttribute('aria-pressed', String(on));
      });
      this.dateWrap.hidden = !this.later;
      this.dateInput.disabled = !(this.gift && this.later);
      if (!this.later) this.dateInput.value = '';
    }

    setLabel(text) {
      this.querySelector('[data-gift-cta-label]').textContent = text;
    }

    showError(text) {
      this.error.textContent = text;
      this.error.hidden = text === '';
    }

    async submit() {
      if (this.gift) {
        const email = this.querySelector('[data-gift-email]').value.trim();
        const okEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        const okDate = !this.later || this.dateInput.value !== '';
        if (!okEmail || !okDate) {
          this.showError(this.cta.dataset.labelInvalid);
          return;
        }
      }
      this.cta.disabled = true;
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(this.form),
        });
        const data = await response.json();
        if (!response.ok) {
          this.showError(data.description || data.message || this.cta.dataset.labelError);
          return;
        }
        this.setLabel(this.cta.dataset.labelAdded);
        clearTimeout(this.addedTimer);
        this.addedTimer = setTimeout(() => this.setLabel(this.cta.dataset.labelAdd), 2500);
        document.dispatchEvent(new CustomEvent('cart:added'));
      } catch (error) {
        this.showError(this.cta.dataset.labelError);
      } finally {
        this.cta.disabled = false;
      }
    }
  }

  if (!customElements.get('gift-card-product')) {
    customElements.define('gift-card-product', GiftCardProduct);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class SiteHeader extends HTMLElement {
    connectedCallback() {
      this.group = this.closest('.site-header-group');
      this.items = Array.from(this.querySelectorAll('[data-mega-item]'));
      this.dialog = this.querySelector('dialog');
      this.openButton = this.querySelector('[data-mobile-open]');

      const imageFirst = document.querySelector('main > .shopify-section:first-child > [data-header-transparent]');
      if (this.group && this.dataset.transparent === 'true' && imageFirst) {
        this.group.classList.add('is-transparent');
        this.onScroll = () => {
          this.group.classList.toggle('is-scrolled', window.scrollY > 40);
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
      }

      this.items.forEach((item) => {
        const trigger = item.querySelector('[data-mega-trigger]');
        if (!trigger) return;
        item.addEventListener('mouseenter', () => this.open(item));
        trigger.addEventListener('focus', () => this.open(item));
        trigger.addEventListener('click', (event) => {
          if (!item.classList.contains('is-open')) {
            event.preventDefault();
            this.open(item);
          }
        });
      });

      this.items.forEach((item) => {
        if (!item.querySelector('[data-mega-trigger]')) {
          item.addEventListener('mouseenter', () => this.closeAll());
        }
      });

      this.addEventListener('mouseleave', () => this.closeAll());
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.closeAll();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.closeAll();
      });

      document.addEventListener('cart:updated', (event) => {
        const count = this.querySelector('[data-cart-count]');
        const label = this.querySelector('[data-cart-count-label]');
        const total = event.detail && event.detail.itemCount;
        if (typeof total !== 'number') return;
        if (count) {
          count.textContent = total;
          count.hidden = total === 0;
        }
        if (label) label.textContent = label.dataset.label.replace('[count]', total);
      });

      if (this.dialog && this.openButton) {
        this.panels = Array.from(this.dialog.querySelectorAll('[data-panel]'));
        this.stack = ['root'];
        this.openButton.addEventListener('click', () => this.openMobile());
        this.dialog.addEventListener('click', (event) => this.onMobileClick(event));
        this.dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.closeMobile();
        });
        this.dialog.addEventListener('close', () => {
          this.openButton.setAttribute('aria-expanded', 'false');
        });
      }
    }

    disconnectedCallback() {
      if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
    }

    open(item) {
      this.items.forEach((other) => {
        const isTarget = other === item;
        other.classList.toggle('is-open', isTarget);
        const trigger = other.querySelector('[data-mega-trigger]');
        if (trigger) trigger.setAttribute('aria-expanded', String(isTarget));
      });
      if (this.group) this.group.classList.add('is-open');
    }

    closeAll() {
      this.items.forEach((item) => {
        item.classList.remove('is-open');
        const trigger = item.querySelector('[data-mega-trigger]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
      if (this.group) this.group.classList.remove('is-open');
    }

    onMobileClick(event) {
      const close = event.target.closest('[data-mobile-close]');
      if (close) return this.closeMobile();

      const open = event.target.closest('[data-panel-open]');
      if (open) {
        this.stack.push(open.dataset.panelOpen);
        this.renderPanels(true);
        return;
      }

      const back = event.target.closest('[data-panel-back]');
      if (back) {
        if (this.stack.length > 1) this.stack.pop();
        this.renderPanels(true);
        return;
      }

      const localization = event.target.closest('[data-mobile-localization]');
      if (localization) {
        this.closeMobile();
        const trigger = document.querySelector('[data-localization-open]');
        if (trigger) setTimeout(() => trigger.click(), 420);
        return;
      }

      if (event.target === this.dialog) this.closeMobile();
    }

    renderPanels(focus) {
      const top = this.stack.length - 1;
      this.panels.forEach((panel) => {
        const depth = this.stack.indexOf(panel.dataset.panel);
        const active = depth === top;
        panel.classList.toggle('is-active', active);
        panel.classList.toggle('is-behind', depth !== -1 && depth < top);
        panel.setAttribute('aria-hidden', String(!active));
        if (active && focus) {
          const target = panel.querySelector('[data-panel-back], [data-mobile-close]');
          if (target) target.focus({ preventScroll: true });
        }
      });
    }

    openMobile() {
      this.closeAll();
      clearTimeout(this.closeTimer);
      this.stack = ['root'];
      this.renderPanels(false);
      this.dialog.showModal();
      requestAnimationFrame(() => {
        requestAnimationFrame(() => this.dialog.classList.add('is-open'));
      });
      this.openButton.setAttribute('aria-expanded', 'true');
    }

    closeMobile() {
      if (!this.dialog.open) return;
      this.dialog.classList.remove('is-open');
      clearTimeout(this.closeTimer);
      this.closeTimer = setTimeout(() => {
        this.dialog.close();
        this.stack = ['root'];
        this.renderPanels(false);
      }, 400);
    }
  }

  if (!customElements.get('site-header')) {
    customElements.define('site-header', SiteHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
  class NewsletterPopup extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-popup-dialog]');
      if (!this.dialog) return;
      this.form = this.querySelector('[data-popup-form]');
      this.email = this.querySelector('[data-popup-email]');
      this.error = this.querySelector('[data-popup-error]');
      this.tags = this.querySelector('[data-popup-tags]');
      this.submitButton = this.querySelector('[data-popup-submit]');
      /* Not this.title: that is the built-in title attribute on every element. */
      this.titleEl = this.querySelector('[data-popup-title]');
      this.codeEl = this.querySelector('[data-popup-code]');
      this.who = 'self';
      this.keys = { dismissed: 'ba-popup-dismissed', subscribed: 'ba-popup-subscribed', pending: 'ba-popup-pending' };
      this.returnInput = this.querySelector('[data-popup-return]');
      this.installSubmitHook();
      this.messages = {
        invalid: this.dataset.invalidEmail,
        failed: this.dataset.failed,
      };

      this.querySelectorAll('[data-popup-close]').forEach((button) => {
        button.addEventListener('click', () => this.dismiss());
      });
      this.querySelector('[data-popup-backdrop]').addEventListener('click', () => {
        if (this.dialog.classList.contains('newsletter-popup--modal')) this.dismiss();
      });
      this.dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.dismiss();
      });
      this.querySelectorAll('[data-popup-pick]').forEach((button) => {
        button.addEventListener('click', () => {
          this.who = button.dataset.popupPick;
          this.titleEl.textContent = this.who === 'gift' ? this.titleEl.dataset.titleGift : this.titleEl.dataset.titleSelf;
          this.tags.value = this.who === 'gift' ? this.dataset.giftTags : this.dataset.selfTags;
          this.showStep(2);
          this.email.focus();
        });
      });
      this.querySelector('[data-popup-back]').addEventListener('click', () => {
        this.showError('');
        this.showStep(1);
      });
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        if (!this.validate()) {
          /* Stop Shopify's CAPTCHA listener on the same event. */
          event.stopImmediatePropagation();
          return;
        }
        this.submit();
      });
      this.email.addEventListener('input', () => this.showError(''));
      this.querySelector('[data-popup-copy]').addEventListener('click', () => this.copy());

      /* Back from Shopify after a successful signup: show the code. */
      if (this.finishPending()) return;

      const designMode = window.Shopify && window.Shopify.designMode;
      if (designMode) {
        // Theme editor: show the popup only while its section is selected.
        const section = this.closest('.shopify-section');
        document.addEventListener('shopify:section:select', (event) => {
          if (section && event.target === section) this.open();
        });
        document.addEventListener('shopify:section:deselect', (event) => {
          if (section && event.target === section) this.closeQuiet();
        });
        return;
      }
      if (this.dataset.enabled !== 'true' || this.suppressed()) return;
      setTimeout(() => this.openWhenClear(), Math.max(0, Number(this.dataset.delay) || 0) * 1000);
    }

    openWhenClear() {
      if (!document.documentElement.hasAttribute('data-cookie-banner-open')) {
        this.open();
        return;
      }
      document.addEventListener(
        'cookie:resolved',
        () => setTimeout(() => this.open(), 1000),
        { once: true }
      );
    }

    read(key) {
      try {
        return window.localStorage.getItem(key);
      } catch (error) {
        return null;
      }
    }

    write(key, value) {
      try {
        window.localStorage.setItem(key, value);
      } catch (error) {
        /* storage unavailable */
      }
    }

    suppressed() {
      if (this.read(this.keys.subscribed)) return true;
      const dismissed = Number(this.read(this.keys.dismissed));
      if (!dismissed) return false;
      const days = Number(this.dataset.days) || 14;
      return Date.now() - dismissed < days * 86400000;
    }

    open() {
      if (this.dialog.open) return;
      this.dialog.showModal();
      requestAnimationFrame(() => this.dialog.classList.add('is-visible'));
    }

    dismiss() {
      this.write(this.keys.dismissed, String(Date.now()));
      this.closeQuiet();
    }

    closeQuiet() {
      if (!this.dialog.open) return;
      this.dialog.classList.remove('is-visible');
      setTimeout(() => this.dialog.close(), 300);
    }

    showStep(step) {
      this.querySelectorAll('[data-popup-step]').forEach((el) => {
        el.hidden = el.dataset.popupStep !== String(step);
      });
    }

    showError(message) {
      this.error.textContent = message;
      this.error.hidden = message === '';
    }

    /* Spam protection (hCaptcha) only adds its token when the form goes
       through Shopify's own submit chain: its script wraps form.submit at
       wire-up, fetches a token on the submit event, then calls the
       form.submit it found when it wired up. Storefront pages cannot be
       framed (CSP frame-ancestors 'none'), so the only way to stay on the
       page is to be that inner submit: we set our own form.submit before
       Shopify wires up, receive the token-filled form and POST it with
       fetch. If the chain ends in a native submit instead, the page reloads
       with ?newsletter=done and finishPending() shows the code. */
    installSubmitHook() {
      const hooked = () => this.postInBackground();
      try {
        Object.defineProperty(this.form, 'submit', { value: hooked, writable: true, configurable: true });
      } catch (error) {
        this.form.submit = hooked;
      }
    }

    validate() {
      const value = this.email.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        this.showError(this.messages.invalid);
        this.email.focus();
        return false;
      }
      return true;
    }

    submit() {
      this.submitButton.disabled = true;
      this.showError('');
      this.posted = false;
      this.write(this.keys.pending, JSON.stringify({ who: this.who, at: Date.now() }));
      if (this.returnInput) {
        const url = new URL(window.location.href);
        url.searchParams.set('newsletter', 'done');
        url.hash = '';
        this.returnInput.value = url.pathname + url.search;
      }
      /* Shopify's CAPTCHA listener on this same submit event takes it from
         here. If nothing has reached our submit within a moment (no CAPTCHA
         wired up), run the chain ourselves. */
      clearTimeout(this.chainTimer);
      this.chainTimer = setTimeout(() => {
        if (!this.posted) this.form.submit();
      }, 1500);
    }

    async postInBackground() {
      if (this.posted) return;
      this.posted = true;
      clearTimeout(this.chainTimer);
      try {
        const response = await fetch(this.form.action, {
          method: 'POST',
          body: new FormData(this.form),
          headers: { Accept: 'text/html' },
        });
        if (response.url.indexOf('/challenge') !== -1) {
          /* Interactive CAPTCHA needed: let the browser do a real submit;
             the page comes back with ?newsletter=done. */
          HTMLFormElement.prototype.submit.call(this.form);
          return;
        }
        if (response.ok && (response.url.indexOf('newsletter=done') !== -1 || response.url.indexOf('customer_posted=true') !== -1)) {
          this.succeeded();
        } else {
          this.failed();
        }
      } catch (error) {
        this.failed();
      }
    }

    succeeded() {
      try {
        window.localStorage.removeItem(this.keys.pending);
      } catch (error) {
        /* storage unavailable */
      }
      this.write(this.keys.subscribed, '1');
      this.codeEl.textContent = this.who === 'gift' ? this.dataset.giftCode : this.dataset.selfCode;
      this.submitButton.disabled = false;
      this.showStep(3);
    }

    failed() {
      this.posted = false;
      this.submitButton.disabled = false;
      this.showError(this.messages.failed);
    }

    finishPending() {
      const params = new URLSearchParams(window.location.search);
      if (params.get('newsletter') !== 'done') return false;
      let pending = null;
      try {
        pending = JSON.parse(this.read(this.keys.pending) || 'null');
      } catch (error) {
        pending = null;
      }
      try {
        window.localStorage.removeItem(this.keys.pending);
      } catch (error) {
        /* storage unavailable */
      }
      params.delete('newsletter');
      params.delete('customer_posted');
      const clean = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
      window.history.replaceState({}, '', clean);
      if (!pending || Date.now() - pending.at > 10 * 60 * 1000) return false;
      this.who = pending.who === 'gift' ? 'gift' : 'self';
      this.write(this.keys.subscribed, '1');
      this.codeEl.textContent = this.who === 'gift' ? this.dataset.giftCode : this.dataset.selfCode;
      this.showStep(3);
      this.open();
      return true;
    }

    copy() {
      const code = this.codeEl.textContent;
      try {
        if (navigator.clipboard) navigator.clipboard.writeText(code);
      } catch (error) {
        /* clipboard unavailable */
      }
      const icon = this.querySelector('[data-popup-copy-icon]');
      const done = this.querySelector('[data-popup-copied-icon]');
      icon.hidden = true;
      done.hidden = false;
      setTimeout(() => {
        icon.hidden = false;
        done.hidden = true;
      }, 1500);
    }
  }

  if (!customElements.get('newsletter-popup')) {
    customElements.define('newsletter-popup', NewsletterPopup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class ProductPage extends HTMLElement {
    connectedCallback() {
      this.optionsChosen = this.dataset.optionsChosen === 'true';
      this.onScroll = () => this.updateCursorVisibility();
      this.onPointerMove = (event) => {
        this.lastPointer = { x: event.clientX, y: event.clientY };
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      document.addEventListener('pointermove', this.onPointerMove, { passive: true });
      this.init();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      document.removeEventListener('pointermove', this.onPointerMove);
      if (this.observer) this.observer.disconnect();
    }

    async loadRecommendations() {
      const block = this.querySelector('[data-product-recs]');
      if (!block || !block.dataset.url) return;
      if (this.recsHtml) {
        const grid = block.querySelector('[data-product-recs-grid]');
        if (grid) grid.innerHTML = this.recsHtml;
        block.hidden = false;
        return;
      }
      try {
        const response = await fetch(block.dataset.url);
        if (!response.ok) return;
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-product-recs-grid]');
        const grid = block.querySelector('[data-product-recs-grid]');
        if (fresh && grid && fresh.children.length > 0) {
          this.recsHtml = fresh.innerHTML;
          grid.innerHTML = this.recsHtml;
          block.hidden = false;
        }
      } catch (error) {
        /* no recommendations */
      }
    }

    init() {
      this.loadRecommendations();
      this.rail = this.querySelector('[data-rail]');
      this.railWrapper = this.querySelector('[data-rail-wrapper]');
      this.cursor = this.querySelector('[data-cursor]');
      this.form = this.querySelector('[data-product-form]');
      this.cta = this.querySelector('[data-cta]');
      this.mobileCta = this.querySelector('[data-mobile-cta]');
      this.setRailTop();
      this.bindOptions();
      this.bindRail();
      this.bindForm();
      this.bindMobileCta();
      this.syncChoiceState();
    }

    setRailTop() {
      const header = document.querySelector('.section-header');
      const top = header ? header.offsetHeight : 52;
      this.style.setProperty('--rail-top', `${top}px`);
    }

    bindOptions() {
      this.querySelectorAll('[data-option-value]').forEach((button) => {
        button.addEventListener('click', () => {
          if (button.dataset.optionType === 'choice') {
            this.optionsChosen = true;
            this.selectChoice(button);
            return;
          }
          this.changeVariant(button.dataset.variantId, true);
        });
      });
    }

    selectChoice(button) {
      const group = button.closest('.product__sizes');
      if (group) {
        group.querySelectorAll('[data-option-type="choice"]').forEach((other) => {
          const isTarget = other === button;
          other.classList.toggle('is-selected', isTarget);
          other.setAttribute('aria-pressed', String(isTarget));
        });
      }

      const variantId = button.dataset.variantId;
      const input = this.querySelector('[data-variant-input]');
      if (input && variantId) input.value = variantId;

      const price = this.querySelector('[data-price]');
      if (price && button.dataset.price) {
        price.innerHTML = button.dataset.comparePrice
          ? `<span class="price price--sale"><s class="price__compare">${button.dataset.comparePrice}</s> <span class="price__current">${button.dataset.price}</span></span>`
          : `<span class="price">${button.dataset.price}</span>`;
      }
      this.querySelectorAll('[data-cta-price], [data-cta-price-mobile]').forEach((el) => {
        if (button.dataset.price) el.innerHTML = button.dataset.price;
      });

      if (this.cta) {
        const available = button.dataset.available === 'true';
        this.cta.disabled = !available;
        this.setLabel(available ? this.cta.dataset.labelAdd : this.cta.dataset.labelSoldOut);
      }

      if (variantId) {
        const params = new URLSearchParams(window.location.search);
        params.set('variant', variantId);
        window.history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`);
      }
    }

    async changeVariant(variantId, resetRail) {
      if (!variantId) return;
      this.classList.add('is-loading');
      const url = `${this.dataset.url}?variant=${variantId}&section_id=${this.dataset.sectionId}`;
      try {
        const response = await fetch(url);
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('product-page');
        if (!fresh) return;
        this.innerHTML = fresh.innerHTML;
        this.init();
        if (resetRail && this.rail) this.rail.scrollLeft = 0;
        const params = new URLSearchParams(window.location.search);
        params.set('variant', variantId);
        window.history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`);
      } finally {
        this.classList.remove('is-loading');
      }
    }

    syncChoiceState() {
      if (!this.cta) return;
      if (!this.optionsChosen) {
        this.querySelectorAll('[data-option-type="choice"]').forEach((button) => {
          button.classList.remove('is-selected');
          button.setAttribute('aria-pressed', 'false');
        });
        if (!this.cta.disabled) this.setLabel(this.cta.dataset.labelChoose);
      }
    }

    setLabel(text) {
      this.querySelectorAll('[data-cta-label], [data-cta-label-mobile]').forEach((el) => {
        el.textContent = text;
      });
    }

    bindForm() {
      if (!this.form || !this.cta) return;
      this.form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (!this.optionsChosen) {
          const firstSize = this.querySelector('[data-option-type="choice"]:not([disabled])');
          if (firstSize) firstSize.focus();
          return;
        }
        if (this.cta.disabled) return;
        this.cta.disabled = true;
        try {
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(this.form),
          });
          if (!response.ok) throw new Error('add failed');
          this.setLabel(this.cta.dataset.labelAdded);
          clearTimeout(this.addedTimer);
          this.addedTimer = setTimeout(() => this.setLabel(this.cta.dataset.labelAdd), 2500);
          document.dispatchEvent(new CustomEvent('cart:added'));
        } catch (error) {
          this.setLabel(this.cta.dataset.labelError);
        } finally {
          this.cta.disabled = false;
        }
      });
    }

    bindMobileCta() {
      if (!this.mobileCta || !this.cta) return;
      if (this.observer) this.observer.disconnect();
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          ([entry]) => this.mobileCta.classList.toggle('is-hidden', entry.isIntersecting),
          { threshold: 0.6 }
        );
        this.observer.observe(this.cta);
      }
      this.mobileCta.addEventListener('click', () => {
        if (this.optionsChosen) {
          this.form.requestSubmit();
          return;
        }
        const y = this.cta.getBoundingClientRect().top + window.scrollY - 160;
        window.scrollTo({ top: y, behavior: 'smooth' });
      });
    }

    bindRail() {
      if (!this.rail || !this.railWrapper || !this.cursor) return;
      let drag = null;
      let moved = false;

      this.railWrapper.addEventListener('pointerenter', () => this.cursor.classList.add('is-visible'));
      this.railWrapper.addEventListener('pointerleave', () => {
        this.cursor.classList.remove('is-visible');
        drag = null;
        this.rail.classList.remove('is-dragging');
      });
      this.railWrapper.addEventListener('pointermove', (event) => {
        this.lastPointer = { x: event.clientX, y: event.clientY };
        this.cursor.style.transform = `translate(${event.clientX}px, ${event.clientY}px)`;
        if (drag) {
          const dx = event.clientX - drag.x;
          if (Math.abs(dx) > 5) moved = true;
          this.rail.scrollLeft = drag.scrollLeft - dx;
        }
      });
      this.railWrapper.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse') return;
        drag = { x: event.clientX, scrollLeft: this.rail.scrollLeft };
        moved = false;
        this.rail.classList.add('is-dragging');
      });
      this.railWrapper.addEventListener('pointerup', (event) => {
        this.rail.classList.remove('is-dragging');
        if (!drag) return;
        drag = null;
        if (moved) return;
        const bounds = this.railWrapper.getBoundingClientRect();
        const direction = event.clientX < bounds.left + bounds.width / 2 ? -1 : 1;
        this.rail.scrollBy({ left: direction * this.rail.clientWidth * 0.72, behavior: 'smooth' });
      });
      this.rail.addEventListener('dragstart', (event) => event.preventDefault());
    }

    updateCursorVisibility() {
      if (!this.cursor || !this.railWrapper || !this.lastPointer) return;
      const b = this.railWrapper.getBoundingClientRect();
      const { x, y } = this.lastPointer;
      const inside = x >= b.left && x <= b.right && y >= b.top && y <= b.bottom;
      this.cursor.style.transform = `translate(px, px)`;
      this.cursor.classList.toggle('is-visible', inside);
    }
  }

  if (!customElements.get('product-page')) {
    customElements.define('product-page', ProductPage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  class RelatedProducts extends HTMLElement {
    connectedCallback() {
      this.bindRail();
      this.load();
    }

    load() {
      if (!('IntersectionObserver' in window)) {
        this.fetchProducts();
        return;
      }
      /* Start well before the rail is in view so the placeholders are
         normally replaced before anyone sees them. */
      const observer = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        this.fetchProducts();
      }, { rootMargin: '0px 0px 1200px 0px' });
      observer.observe(this);
    }

    async fetchProducts() {
      try {
        const response = await fetch(this.dataset.url);
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('related-products');
        if (fresh && fresh.innerHTML.trim().length) {
          this.innerHTML = fresh.innerHTML;
          this.bindRail();
          const rail = this.querySelector('[data-rail]');
          if (rail) rail.classList.add('is-ready');
          return;
        }
      } catch (error) {
        /* recommendations unavailable, use the fallback below */
      }
      this.useFallback();
    }

    useFallback() {
      const template = this.querySelector('[data-fallback]');
      const rail = this.querySelector('[data-rail]');
      if (!template || !rail) {
        this.innerHTML = '';
        return;
      }
      rail.innerHTML = '';
      rail.appendChild(template.content.cloneNode(true));
      rail.removeAttribute('aria-busy');
      rail.classList.add('is-ready');
      template.remove();
    }

    bindRail() {
      const wrapper = this.querySelector('[data-rail-wrapper]');
      const rail = this.querySelector('[data-rail]');
      const cursor = this.querySelector('[data-cursor]');
      if (!wrapper || !rail || !cursor) return;
      let drag = null;
      let moved = false;

      wrapper.addEventListener('pointerenter', () => cursor.classList.add('is-visible'));
      wrapper.addEventListener('pointerleave', () => {
        cursor.classList.remove('is-visible');
        drag = null;
        rail.classList.remove('is-dragging');
      });
      wrapper.addEventListener('pointermove', (event) => {
        cursor.style.transform = `translate(${event.clientX}px, ${event.clientY}px)`;
        if (drag) {
          const dx = event.clientX - drag.x;
          if (Math.abs(dx) > 5) moved = true;
          rail.scrollLeft = drag.scrollLeft - dx;
        }
      });
      wrapper.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse') return;
        drag = { x: event.clientX, scrollLeft: rail.scrollLeft };
        moved = false;
        rail.classList.add('is-dragging');
      });
      wrapper.addEventListener('pointerup', () => {
        rail.classList.remove('is-dragging');
        drag = null;
      });
      wrapper.addEventListener('click', (event) => {
        if (moved) {
          event.preventDefault();
          moved = false;
        }
      }, true);
      rail.addEventListener('dragstart', (event) => event.preventDefault());
    }
  }

  if (!customElements.get('related-products')) {
    customElements.define('related-products', RelatedProducts);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saved"]) return;
  try {
    
  class SavedProducts extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-saved-grid]');
      this.empty = this.querySelector('[data-saved-empty]');
      this.countLabel = this.querySelector('[data-saved-count-label]');
      this.cards = new Map();
      this.render();
      document.addEventListener('saved:changed', () => this.render());
    }

    handles() {
      return window.BrownSaved ? window.BrownSaved.list() : [];
    }

    setCount(n) {
      this.countLabel.textContent = this.dataset.countLabel.replace('[count]', n);
    }

    async render() {
      const handles = this.handles();
      this.setCount(handles.length);
      this.empty.hidden = handles.length > 0;

      for (const [handle, card] of this.cards) {
        if (!handles.includes(handle)) {
          card.remove();
          this.cards.delete(handle);
        }
      }

      const missing = handles.filter((h) => !this.cards.has(h));
      const fetched = await Promise.all(missing.map((h) => this.fetchCard(h)));
      fetched.forEach((card, i) => {
        const handle = missing[i];
        if (card) {
          this.cards.set(handle, card);
        } else if (window.BrownSaved) {
          window.BrownSaved.remove(handle);
        }
      });

      const ordered = this.handles().filter((h) => this.cards.has(h));
      ordered.forEach((h) => this.grid.appendChild(this.cards.get(h)));
      this.setCount(ordered.length);
      this.empty.hidden = ordered.length > 0;
      if (window.BrownSaved) window.BrownSaved.sync();
    }

    async fetchCard(handle) {
      try {
        const response = await fetch(this.dataset.cardUrl.replace('[handle]', encodeURIComponent(handle)));
        if (!response.ok) return null;
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.querySelector('.product-card');
      } catch (error) {
        return null;
      }
    }
  }

  if (!customElements.get('saved-products')) {
    customElements.define('saved-products', SavedProducts);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-drawer"]) return;
  try {
    
  class SearchDrawer extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('.search-drawer__panel');
      this.input = this.querySelector('[data-search-input]');
      this.form = this.querySelector('[data-search-form]');
      this.clear = this.querySelector('[data-search-clear]');
      this.popular = this.querySelector('[data-search-popular]');
      this.suggestions = this.querySelector('[data-search-suggestions]');
      this.suggestionsList = this.querySelector('[data-search-suggestions-list]');
      this.empty = this.querySelector('[data-search-empty]');
      this.emptyTerm = this.querySelector('[data-search-empty-term]');
      this.recommended = this.querySelector('[data-search-recommended]');
      this.results = this.querySelector('[data-search-results]');
      this.resultsHeading = this.querySelector('[data-search-results-heading]');
      this.resultsGrid = this.querySelector('[data-search-results-grid]');
      this.footer = this.querySelector('[data-search-footer]');
      this.allLink = this.querySelector('[data-search-all]');
      this.allCount = this.querySelector('[data-search-all-count]');
      this.isOpen = false;
      this.requestId = 0;
      this.strings = {
        one: this.dataset.labelOne,
        many: this.dataset.labelMany,
      };

      this.querySelector('[data-search-overlay]').addEventListener('click', () => this.close());
      this.querySelectorAll('[data-search-close]').forEach((button) => button.addEventListener('click', () => this.close()));
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.isOpen) this.close();
      });
      document.querySelectorAll('[data-search-toggle]').forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.open();
        });
      });

      this.input.addEventListener('input', () => {
        clearTimeout(this.timer);
        this.clear.hidden = this.input.value.trim() === '';
        this.timer = setTimeout(() => this.search(this.input.value), 250);
      });
      this.clear.addEventListener('click', () => {
        this.input.value = '';
        this.input.focus();
        this.reset();
      });
      this.form.addEventListener('submit', (event) => {
        if (this.input.value.trim() === '') event.preventDefault();
      });
      this.addEventListener('click', (event) => {
        const term = event.target.closest('[data-search-term]');
        if (term) {
          this.input.value = term.dataset.searchTerm;
          this.clear.hidden = false;
          this.search(term.dataset.searchTerm);
          this.input.focus();
        }
      });
    }

    open() {
      if (this.isOpen) return;
      this.isOpen = true;
      this.lastFocus = document.activeElement;
      this.classList.remove('is-closing');
      this.classList.add('is-open');
      document.documentElement.classList.add('cart-drawer-open');
      setTimeout(() => this.input.focus(), 50);
    }

    close() {
      if (!this.isOpen) return;
      this.isOpen = false;
      this.classList.remove('is-open');
      this.classList.add('is-closing');
      document.documentElement.classList.remove('cart-drawer-open');
      const done = () => {
        this.classList.remove('is-closing');
        this.panel.removeEventListener('transitionend', done);
      };
      this.panel.addEventListener('transitionend', done);
      setTimeout(done, 500);
      if (this.lastFocus && typeof this.lastFocus.focus === 'function') this.lastFocus.focus();
    }

    reset() {
      this.requestId += 1;
      this.clear.hidden = true;
      if (this.popular) this.popular.hidden = false;
      if (this.recommended) this.recommended.hidden = false;
      this.suggestions.hidden = true;
      this.empty.hidden = true;
      this.results.hidden = true;
      this.footer.hidden = true;
      this.classList.remove('is-loading');
    }

    async search(value) {
      const query = value.trim();
      if (query.length < 2) {
        this.reset();
        this.clear.hidden = query === '';
        return;
      }
      const id = (this.requestId += 1);
      this.classList.add('is-loading');
      const encoded = encodeURIComponent(query);
      const sectionUrl = `${this.dataset.searchUrl}?q=${encoded}&type=product&section_id=${this.dataset.sectionId}`;
      const suggestUrl = `${this.dataset.predictiveUrl}.json?q=${encoded}&resources[type]=query&resources[limit]=5`;

      try {
        const [sectionResponse, suggestResponse] = await Promise.all([
          fetch(sectionUrl),
          fetch(suggestUrl).catch(() => null),
        ]);
        if (id !== this.requestId) return;

        const html = await sectionResponse.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fragment = doc.querySelector('[data-search-fragment]');
        const count = fragment ? Number(fragment.dataset.count) : 0;
        const items = fragment ? fragment.content.children.length : 0;

        let queries = [];
        if (suggestResponse && suggestResponse.ok) {
          const data = await suggestResponse.json();
          queries = ((data.resources && data.resources.results && data.resources.results.queries) || [])
            .map((item) => item.text)
            .filter((text) => text && text.toLowerCase() !== query.toLowerCase());
        }
        if (id !== this.requestId) return;

        if (this.recommended) this.recommended.hidden = true;
        this.suggestionsList.innerHTML = '';
        queries.forEach((text) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'search-drawer__term link-hover';
          button.dataset.searchTerm = text;
          button.textContent = text;
          this.suggestionsList.appendChild(button);
        });
        this.suggestions.hidden = queries.length === 0;

        if (items > 0 && fragment) {
          this.resultsGrid.innerHTML = fragment.innerHTML;
          this.resultsHeading.textContent = count === 1 ? this.strings.one : this.strings.many.replace('[count]', count);
          this.results.hidden = false;
          this.empty.hidden = true;
          if (this.popular) this.popular.hidden = true;
          this.allLink.href = `${this.dataset.searchUrl}?q=${encoded}&type=product`;
          this.allCount.textContent = count;
          this.footer.hidden = false;
        } else {
          this.results.hidden = true;
          this.footer.hidden = true;
          this.emptyTerm.textContent = query;
          this.empty.hidden = false;
          if (this.popular) this.popular.hidden = false;
        }
      } catch (error) {
        if (id === this.requestId) this.reset();
      } finally {
        if (id === this.requestId) this.classList.remove('is-loading');
      }
    }
  }

  if (!customElements.get('search-drawer')) {
    customElements.define('search-drawer', SearchDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locator"] && !Shopify.designMode) return;
  try {
    
  class StoreLocator extends HTMLElement {
    connectedCallback() {
      this.filters = Array.from(this.querySelectorAll('[data-store-filter]'));
      this.stores = Array.from(this.querySelectorAll('[data-store]'));
      this.empty = this.querySelector('[data-store-empty]');
      this.filters.forEach((select) => select.addEventListener('change', () => this.apply()));
    }

    apply() {
      const wanted = {};
      this.filters.forEach((select) => {
        wanted[select.dataset.storeFilter] = select.value;
      });
      let visible = 0;
      this.stores.forEach((store) => {
        const match =
          (!wanted.country || store.dataset.country === wanted.country) &&
          (!wanted.type || store.dataset.type === wanted.type);
        store.hidden = !match;
        if (match) visible += 1;
      });
      if (this.empty) this.empty.hidden = visible > 0;
    }
  }

  if (!customElements.get('store-locator')) {
    customElements.define('store-locator', StoreLocator);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support-page"]) return;
  try {
    
  class ContactForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form || !this.querySelector('[data-step="1"]')) return;
      this.step = 1;
      this.topic = this.form.querySelector('[data-topic]');
      this.error = this.querySelector('[data-error]');
      this.next = this.querySelector('[data-next]');
      this.backButton = this.querySelector('[data-back]');
      this.stepLabel = this.querySelector('[data-form-step]');
      /* Not this.title: that is the built-in title attribute on every element. */
      this.titleEl = this.querySelector('[data-form-title]');
      this.steps = Array.from(this.querySelectorAll('[data-step]'));

      this.topic.addEventListener('change', () => this.showError(''));
      this.next.addEventListener('click', () => this.advance());
      this.backButton.addEventListener('click', () => this.go(this.step - 1));
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        if (this.step < 3 || !this.valid()) {
          event.stopImmediatePropagation();
          this.advance();
          return;
        }
        this.send();
      });
      /* See the newsletter popup: be the inner submit of Shopify's CAPTCHA
         chain so the form can be posted with fetch, without a reload. */
      const hooked = () => this.postInBackground();
      try {
        Object.defineProperty(this.form, 'submit', { value: hooked, writable: true, configurable: true });
      } catch (error) {
        this.form.submit = hooked;
      }
      this.go(1);
    }

    fields() {
      const option = this.topic.options[this.topic.selectedIndex];
      return (option && option.dataset.fields ? option.dataset.fields : '').split(',').map((item) => item.trim());
    }

    go(step) {
      this.step = Math.max(1, Math.min(3, step));
      this.steps.forEach((el) => {
        el.hidden = el.dataset.step !== String(this.step);
      });
      if (this.step === 2) {
        const wanted = this.fields();
        this.querySelectorAll('[data-field]').forEach((label) => {
          const show = wanted.indexOf(label.dataset.field) !== -1;
          label.hidden = !show;
          label.querySelectorAll('input, select').forEach((input) => {
            input.disabled = !show;
          });
        });
      }
      if (this.step === 3) {
        const name = this.form.querySelector('[name="contact[name]"]').value;
        const email = this.form.querySelector('[name="contact[email]"]').value;
        this.querySelector('[data-summary]').textContent = `${this.topic.value}, ${name}, ${email}`;
      }
      this.titleEl.textContent = this.step === 3 ? this.titleEl.dataset.title3 : this.titleEl.dataset.title1;
      this.stepLabel.textContent = this.stepLabel.dataset.template.replace('[current]', this.step);
      this.next.textContent = this.step === 3 ? this.next.dataset.labelSend : this.next.dataset.labelNext;
      this.backButton.hidden = this.step === 1;
      this.showError('');
    }

    showError(message) {
      this.error.textContent = message;
      this.error.hidden = message === '';
    }

    valid() {
      if (this.step === 1) {
        if (!this.topic.value) {
          this.showError(this.error.dataset.msgTopic);
          return false;
        }
        return true;
      }
      const scope = this.querySelector(`[data-step="${this.step}"]`);
      const inputs = Array.from(scope.querySelectorAll('[data-required]'));
      const reason = scope.querySelector('[data-field="reason"]:not([hidden]) select');
      const order = scope.querySelector('[data-field="order"]:not([hidden]) input');
      const product = scope.querySelector('[data-field="product"]:not([hidden]) input');
      const missing = inputs.some((input) => {
        const value = input.value.trim();
        if (!value) return true;
        return input.hasAttribute('data-email') && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
      });
      if (this.step === 3 && missing) {
        this.showError(this.error.dataset.msgMessage);
        return false;
      }
      if (missing || (reason && !reason.value) || (order && !order.value.trim()) || (product && !product.value.trim())) {
        this.showError(this.error.dataset.msgFields);
        return false;
      }
      return true;
    }

    advance() {
      if (!this.valid()) return;
      if (this.step === 1) {
        /* A topic with a redirect (third part of the topic line) sends the
           visitor straight to that page, on the current language. */
        const option = this.topic.options[this.topic.selectedIndex];
        const redirect = option && option.dataset.redirect;
        if (redirect) {
          const root = (this.dataset.root || '/').replace(/\/$/, '');
          window.location.href = /^https?:/.test(redirect) ? redirect : root + '/' + redirect.replace(/^\//, '');
          return;
        }
      }
      if (this.step < 3) {
        this.go(this.step + 1);
        return;
      }
      /* Step 3: a real submit event lets Shopify's CAPTCHA add its token. */
      this.form.requestSubmit();
    }

    send() {
      this.next.disabled = true;
      this.posted = false;
      const returnInput = this.querySelector('[data-form-return]');
      if (returnInput) {
        const url = new URL(window.location.href);
        url.searchParams.set('contact', 'done');
        url.hash = '';
        returnInput.value = url.pathname + url.search;
      }
      clearTimeout(this.chainTimer);
      this.chainTimer = setTimeout(() => {
        if (!this.posted) this.form.submit();
      }, 1500);
    }

    async postInBackground() {
      if (this.posted) return;
      this.posted = true;
      clearTimeout(this.chainTimer);
      try {
        const response = await fetch(this.form.action, {
          method: 'POST',
          body: new FormData(this.form),
          headers: { Accept: 'text/html' },
        });
        if (response.url.indexOf('/challenge') !== -1) {
          HTMLFormElement.prototype.submit.call(this.form);
          return;
        }
        if (response.ok && (response.url.indexOf('contact=done') !== -1 || response.url.indexOf('contact_posted=true') !== -1)) {
          this.sendDone();
        } else {
          this.sendFailed();
        }
      } catch (error) {
        this.sendFailed();
      }
    }

    sendDone() {
      this.next.disabled = false;
      this.form.hidden = true;
      const done = document.createElement('div');
      done.className = 'support-text';
      done.innerHTML = `<p>${this.dataset.done}</p>`;
      this.appendChild(done);
    }

    sendFailed() {
      clearTimeout(this.chainTimer);
      this.posted = false;
      this.next.disabled = false;
      this.showError(this.error.dataset.msgFailed);
    }
  }

  if (!customElements.get('contact-form')) {
    customElements.define('contact-form', ContactForm);
  }

  } catch(e) { console.error(e); }
})();
})();
